import { MapPin, Warehouse, Truck, Recycle } from "lucide-react";
import { IMG } from "../data/site";
import { PageHero, CTASection, CTAButtons } from "../components/Sections";
import { useLanguage } from "../i18n/LanguageContext";

const FOCUS_ICONS = [MapPin, Warehouse, Truck, Recycle];

const About = () => {
  const { t } = useLanguage();
  const a = t.about;

  return (
    <main data-testid="about-page">
      <PageHero overline={a.overline} title={a.title} intro={a.intro} img={IMG.forkliftOutdoor} />

      <section className="bg-white">
        <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-12 py-16 lg:py-24 grid grid-cols-1 lg:grid-cols-2 gap-12 lg:gap-16 items-center">
          <div>
            <p className="font-mono2 text-xs uppercase tracking-[0.25em] text-amber-700 font-semibold mb-3">{a.storyOverline}</p>
            <h2 className="font-heading text-2xl sm:text-3xl lg:text-4xl font-bold tracking-tight text-slate-900 leading-tight" data-testid="about-story-title">
              {a.storyTitle}
            </h2>
            <p className="mt-5 text-sm sm:text-base text-slate-600 leading-relaxed" data-testid="about-story-text">
              {a.storyText}
            </p>
            <div className="mt-8">
              <CTAButtons testidPrefix="about" />
            </div>
          </div>
          <div className="grid grid-cols-2 gap-4">
            <img src={IMG.aerialYard} alt="Pallet yard" className="w-full h-56 lg:h-64 object-cover border border-slate-200" loading="lazy" />
            <img src={IMG.forkliftOutdoor} alt="Forklift moving pallets" className="w-full h-56 lg:h-64 object-cover border border-slate-200 mt-8" loading="lazy" />
            <img src={IMG.forklift} alt="Warehouse interior" className="w-full h-56 lg:h-64 object-cover border border-slate-200 -mt-8" loading="lazy" />
            <img src={IMG.palletStack} alt="Stacked pallets" className="w-full h-56 lg:h-64 object-cover border border-slate-200" loading="lazy" />
          </div>
        </div>
      </section>

      <section className="bg-slate-950 text-white">
        <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-12 py-16 lg:py-24">
          <p className="font-mono2 text-xs uppercase tracking-[0.25em] text-amber-500 font-semibold mb-3">{a.focusOverline}</p>
          <h2 className="font-heading text-2xl sm:text-3xl lg:text-4xl font-bold tracking-tight leading-tight mb-12" data-testid="about-focus-title">
            {a.focusTitle}
          </h2>
          <div className="grid grid-cols-1 sm:grid-cols-2 lg:grid-cols-4 gap-6">
            {a.focuses.map((f, i) => {
              const Icon = FOCUS_ICONS[i];
              return (
                <div key={i} data-testid={`about-focus-${i}`} className="border border-slate-800 bg-slate-900/50 p-7 hover:border-amber-600 transition-colors">
                  <Icon className="h-7 w-7 text-amber-500 mb-5" />
                  <h3 className="font-heading text-lg font-bold tracking-tight mb-2">{f.title}</h3>
                  <p className="text-sm text-slate-400 leading-relaxed">{f.desc}</p>
                </div>
              );
            })}
          </div>
        </div>
      </section>

      <CTASection />
    </main>
  );
};

export default About;
